import keyBy from 'lodash/keyBy';

import {EChannelParameter, ESystemParameter, TItem, TItemsMap} from './definitions';

export const isSystemParameter = (code: TItem['code']): code is ESystemParameter =>
  Object.values(ESystemParameter).includes(code as ESystemParameter);

export const isChannelParameter = (code: TItem['code']): code is EChannelParameter =>
  Object.values(EChannelParameter).includes(code as EChannelParameter);

export const getParametersOptions = (
  parametersContent: TItem[],
  {withBraces}: {withBraces?: boolean} = {withBraces: true},
) =>
  parametersContent.map((item) => ({
    id: item.id,
    value: withBraces ? `{{${item.name}}}` : item.name,
    label: item.name,
  }));

export const transformContentToItemsMap = (content: TItem[]): TItemsMap => keyBy(content, 'id');

export const getItemById = (itemsMap: TItemsMap, id: TItem['id']) => itemsMap[id] || null;
